module.exports = __webpack_public_path__ + "static/img/img-cp5.16bdd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp5.png
// module id = FoSy
// module chunks = 0